@if (isError) {
  <message-banner [config]="errorBannerData"> </message-banner>
}

@if (iframeSrc) {
  <iframe
    #iframe
    class="u-maxX"
    [ngStyle]="{ height: config.height ? config.height : '100vh' }"
    [src]="iframeSrc"
    frameborder="0"
    (load)="iframeLoaded()"
  >
  </iframe>
} @else {
  <div class="u-flex u-justifyCenter u-maxX">
    <preloader size="small"></preloader>
  </div>
}
